import React, { useState } from 'react';
import Button from '../../components/Button/Button';
import { downloadChapea } from '../../services/exportChapeaHeartRateData';

import './IotDownloadPage.css';

export default function IotDownloadPage() {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [weekLabel, setWeekLabel] = useState('');
  const [status, setStatus] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const datesValid = Boolean(startDate && endDate) && startDate <= endDate;
  const canDownload = Boolean(datesValid && weekLabel) && !isLoading;

  const handleDownload = async () => {
    if (!canDownload) return;
    if (startDate > endDate) {
      setStatus({ error: 'Start date must be on or before end date.' });
      return;
    }
    setStatus({});
    setIsLoading(true);
    try {
      const result = await downloadChapea({ startDate, endDate, weekLabel });
      const { download_url: downloadUrl, error } = result || {};
      if (!downloadUrl) {
        setStatus({ error: error || 'No download was produced for the selected range.' });
        return;
      }
      setStatus({ result });
      window.location.href = downloadUrl;
    } catch (e) {
      setStatus({ error: e.message });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="iot-download-page">
      <div className="iot-download-title">IOT Download</div>
      <div className="iot-download-form">
        <label className="iot-download-field" htmlFor="iot-download-start-date">
          Start Date
          <input
            id="iot-download-start-date"
            type="date"
            value={startDate}
            onChange={({ target: { value } }) => setStartDate(value)}
          />
        </label>
        <label className="iot-download-field" htmlFor="iot-download-end-date">
          End Date
          <input
            id="iot-download-end-date"
            type="date"
            value={endDate}
            onChange={({ target: { value } }) => setEndDate(value)}
          />
        </label>
        <label className="iot-download-field" htmlFor="iot-download-week-label">
          Week Label
          <input
            id="iot-download-week-label"
            type="text"
            value={weekLabel}
            placeholder="Week8"
            onChange={({ target: { value } }) => setWeekLabel(value)}
          />
        </label>
        <Button
          cName={canDownload ? 'iot-download-button' : 'iot-download-button disabled'}
          onClick={handleDownload}
          label={isLoading ? 'Downloading...' : 'Download'}
        />
      </div>
      {isLoading ? (
        <div className="iot-download-progress">
          Preparing your download. Larger date ranges can take a few minutes — please keep this tab open while we build your file.
        </div>
      ) : null}
      {status.error ? <div className="iot-download-error">{status.error}</div> : null}
      {status.result ? (
        <div className="iot-download-result">
          {`Prepared ${status.result.zip_name} (${status.result.file_count} files).`}
        </div>
      ) : null}
    </div>
  );
}
